import { Button, Paper, Tab, Tabs, TextField, ButtonGroup, Tooltip, IconButton, Dialog, TableContainer, TableHead, TableRow, Table, TableCell, TableBody } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { getTickets, approveReceipt, deleteTicket, getRPTPDF, checkImpReceipt } from "../../../services/api";
import TicketForm from "./ticketPreview";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import { useReactToPrint } from "react-to-print";
import TicketPreview from "../commons/ticketPreview.component";
import CloseIcon from "@mui/icons-material/Close";
import { statusColor } from "../../config";
import moment from "moment";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { useTranslation } from "react-i18next";
import { DeleteDialog } from "../../commons/dialog.component";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useSnackbar } from "notistack";

/** Config */
import { exp_inventories } from "./config";

export const TicketContext = React.createContext();

export function ImpTicketDetail({ ticketid, onSaveResponse }) {
  // hook
  const [t] = useTranslation();
  const printRef = useRef();
  const editButtonRef = useRef();
  // state
  const [isAllow, setAllow] = useState(true);
  const [ticketData, setTicketData] = useState();
  const [currentTab, setCurrentTab] = useState(0);
  const [inputData, setInputData] = useState({
    reexport_quantity: "",
    // billdate: '',
    contract_date: "",
    contract_no: "",
    tntxLTT: "",
    tntxKG: "",
    tntxL15: "",
  });
  const [hidden, setHidden] = useState(true);
  const importProcess = ticketData?.receipt.process && JSON.parse(ticketData.receipt.process)?.IMPORT;
  const { enqueueSnackbar } = useSnackbar();

  const fetchNewData = () => {
    getTickets({ id: ticketid }).then((res) => {
      if (res.code === 403) {
        setAllow(false);
        return;
      }
      res.code === 200 && setTicketData(res.data);
    });
  };
  const handleSubmit = () => {
    return approveReceipt(ticketid, {
      reexport_quantity: inputData.reexport_quantity || null,
      contract_no: inputData.contract_no || null,
      tntxLTT: Math.round(inputData.tntxLTT) || null,
      tntxKG: Math.round(inputData.tntxKG) || null,
      tntxL15: Math.round(inputData.tntxL15) || null,
      contract_date: (inputData.contract_date && moment(inputData.contract_date).format("YYYY-MM-DD")) || null,
      // billdate: inputData.billdate && moment(inputData.billdate).format('YYYY-MM-DD HH:mm') || undefined,
    });
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      try {
        let newTicketData = res.data;
        setTicketData(newTicketData);
        onSaveResponse(ticketid);
      } catch (error) {}
    }
  };

  /** Handle check information and update value */
  /** fetchData if ok */
  const handleCheckImpReceipt = () => {
    checkImpReceipt(ticketData?.receipt.id).then((res) => {
      enqueueSnackbar(res.message);
      if (res.code === 200) fetchNewData();
    });
  };
  useEffect(() => {
    if (!hidden) {
      printRef.current && handlePrint();
      setHidden(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  useEffect(() => {
    if (!ticketid) return;
    fetchNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketid]);

  useEffect(() => {
    if (ticketData)
      setInputData({
        reexport_quantity: ticketData.receipt?.reexport_quantity || "",
        // billdate: ticketData.receipt?.billdate || '',
        contract_date: ticketData.receipt?.contract_date || "",
        contract_no: ticketData.receipt?.contract_no || "",
        tntxLTT: ticketData.receipt?.tntxLTT || "",
        tntxKG: ticketData.receipt?.tntxKG || "",
        tntxL15: ticketData.receipt?.tntxL15 || "",
      });
  }, [ticketData]);

  if (!isAllow) return t("No permission");
  if (ticketData)
    return (
      <TicketContext.Provider value={ticketData}>
        <div>
          {Boolean(ticketData.forms) && (
            <>
              <div style={{ paddingBottom: 0, display: "flex", position: "relative", justifyContent: "center", alignItems: "center", backgroundColor: "#b3deff" }}>
                <Tabs value={currentTab} style={{ position: "relative", margin: "auto" }}>
                  <Tab onClick={() => setCurrentTab(0)} label={t("Chi tiết")} />
                  {importProcess &&
                    Object.keys(ticketData.forms)
                      .filter((item) => importProcess[item])
                      .map((key) => <Tab key={key} value={key} onClick={() => setCurrentTab(key)} label={key} />)}
                </Tabs>
                <div style={{ position: "absolute", right: 0 }}>
                  <ButtonGroup style={{ height: 48 }}>
                    {ticketData.receipt?.status !== "FAIL" && (
                      <Tooltip title="Xem file PDF">
                        <ButtonWithAPICallComponent
                          variant="outlined"
                          api={() => {
                            return getRPTPDF(ticketid);
                          }}
                          response={(res) => {
                            res.code === 200 && window.open(res.data);
                          }}
                        >
                          <PictureAsPdfIcon />
                        </ButtonWithAPICallComponent>
                      </Tooltip>
                    )}
                    {/* <Tooltip title='Save'> */}
                    {editButtonRef.current}
                    {/* </Tooltip> */}
                    <Tooltip title="In lại">
                      <Button variant="outlined" color="primary" onClick={() => setHidden(false)}>
                        <PrintIcon />
                      </Button>
                    </Tooltip>
                  </ButtonGroup>
                </div>
              </div>
              {importProcess &&
                Object.keys(ticketData.forms)
                  .filter((item) => importProcess[item])
                  .map((key, index) => (
                    <div key={index} hidden={currentTab !== key}>
                      <TicketForm
                        ticketData={ticketData}
                        onUpdateSuccess={() => fetchNewData()}
                        editButtonRef={currentTab === key ? editButtonRef : null}
                        printRef={currentTab === key ? printRef : null}
                        code={key}
                        ticketid={ticketData.receipt.id}
                        data={ticketData.forms[key]}
                      />
                    </div>
                  ))}
            </>
          )}
          <div hidden={currentTab !== 0}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <h2>Phiếu xuất: {ticketData.receipt?.code}</h2>
              <div className={`status ${ticketData.receipt?.status}`} style={{ color: statusColor[ticketData.receipt?.status] }}>
                {t(ticketData.receipt?.status)}
              </div>
            </div>
            <div align="left" style={{ marginBottom: 5 }}>
              <b>{t("Thông tin kho phiếu xuất")}</b>:
            </div>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      {t("Kho xuất")}: {ticketData?.receipt.from_inventory}
                    </TableCell>
                    <TableCell align="left">
                      {t("Serial số")}: {ticketData?.receipt.serial}
                    </TableCell>
                    <TableCell align="left">
                      {t("Form số")}: {ticketData?.receipt.form_no}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Thời gian bắt đầu")}: {ticketData?.receipt.date && moment(ticketData.receipt.date).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      {t("Thời gian kết thúc")}: {ticketData?.receipt.enddate && moment(ticketData.receipt.enddate).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Phương tiện")}: {ticketData?.receipt.license_plate}
                    </TableCell>
                    <TableCell align="left">
                      {t("Người điều khiển")}: {ticketData?.receipt.driver}
                    </TableCell>
                    <TableCell align="left">
                      {t("Lệnh điều động số")}: {ticketData?.receipt.orderno}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Chứng chỉ kho xuất số/ngày")}: {ticketData?.receipt.inventory_cert}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      {t("Phiếu nhập/Ký hiệu")}: {ticketData?.receipt.ext_inv_serial}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">Lit: {Math.round(ticketData?.receipt.lit)?.toLocaleString()}</TableCell>
                    <TableCell align="left" colSpan={2}>
                      L15: {Math.round(ticketData?.receipt.l15)?.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Ngày xuất hóa đơn")}: {ticketData?.receipt.billdate && moment(ticketData.receipt.billdate).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                    <TableCell align="left">
                      {t("Số hợp đồng")}: {ticketData?.receipt.contract_no}
                    </TableCell>
                    <TableCell align="left">
                      {t("Ngày hợp đồng")}: {ticketData?.receipt.contract_date && moment(ticketData.receipt.contract_date).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div>
              <div align="left" style={{ margin: "10px 0", display: "flex" }}>
                <div style={{ width: "auto" }}>
                  <b>{t("Khoảng cách tầm mức")}:</b>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: `repeat(${JSON.parse(ticketData.receipt.ext_vh_tanks).length}, 1fr)`, gridColumnGap: 20 }}>
                  {JSON.parse(ticketData.receipt.ext_vh_tanks).map((item, index) => (
                    // <TextField InputLabelProps={{shrink: true}} key={index} label={item.code} value={item.lit || ''}/>
                    <div key={index}>
                      {item.code}: {item.lit};
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ margin: "10px 0" }}>
                <div align="left" style={{ marginBottom: 5 }}>
                  <b>{t("Thông tin hàng hóa")}:</b>
                </div>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("STT")}</TableCell>
                        <TableCell>{t("Mã hàng hóa")}</TableCell>
                        <TableCell>{t("Tên hàng hóa")}</TableCell>
                        <TableCell>{t("Nhiệt độ")}</TableCell>
                        <TableCell>D15</TableCell>
                        <TableCell>VCF</TableCell>
                        <TableCell>WCF</TableCell>
                        <TableCell>Lit</TableCell>
                        <TableCell>Lit (15℃)</TableCell>
                        <TableCell>Kg</TableCell>
                        <TableCell>{t("Bồn xuất")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ticketData.receiptproduct &&
                        ticketData.receiptproduct.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.product_name}</TableCell>
                            <TableCell>{item.temp && parseFloat(item.temp)?.toFixed(2)}</TableCell>
                            <TableCell>{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                            <TableCell>{item.vcf && parseFloat(item.vcf)?.toFixed(4)}</TableCell>
                            <TableCell>{item.wcf && parseFloat(item.wcf)?.toFixed(4)}</TableCell>
                            <TableCell>{Math.round(item.lit)?.toLocaleString()}</TableCell>
                            <TableCell>{Math.round(item.l15)?.toLocaleString()}</TableCell>
                            <TableCell>{Math.round(item.kg)?.toLocaleString()}</TableCell>
                            <TableCell>{item.tank && JSON.parse(item.tank)?.code}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>Thông tin kho nhập:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        {t("Kho nhập")}: {ticketData?.receipt.to_inventory}
                      </TableCell>
                      <TableCell align="left">
                        {t("Ngày")}: {ticketData && moment(ticketData.receipt.date).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell align="left">
                        {t("Giờ")} : {moment(ticketData?.receipt.date).format("HH:mm")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">ERP ID: {ticketData?.receipt.erp_id}</TableCell>
                      <TableCell align="left">Số CTT ERP: {ticketData?.receipt.erp_code}</TableCell>
                      <TableCell align="left" colSpan={2}>
                        Fkey : {ticketData?.receipt.fkey}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Lit: {Math.round(ticketData?.receipt.imp_lit)?.toLocaleString()}</TableCell>
                      <TableCell align="left">L15: {Math.round(ticketData?.receipt.imp_l15)?.toLocaleString()}</TableCell>
                      <TableCell align="left">
                        {t("Chênh lệch")}: {Math.round(ticketData?.receipt.gap)?.toLocaleString()}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>{t("Thông tin bể nhập")}</b>:
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        {t("Code")}: {ticketData?.imp_tank.map((item) => item.description)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>Thông tin hóa nghiệm:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        {t("Nhiệt độ")}: {ticketData?.receipt.imp_temp && parseFloat(ticketData?.receipt.imp_temp).toFixed(2)}
                      </TableCell>
                      <TableCell align="left">
                        {t("Tỷ trọng")}: {ticketData?.receipt.imp_density && parseFloat(ticketData?.receipt.imp_density).toFixed(4)}
                      </TableCell>
                      <TableCell align="left">D15: {ticketData?.receipt.imp_d15 && parseFloat(ticketData?.receipt.imp_d15)?.toFixed(4)}</TableCell>
                      <TableCell align="left">VCF: {ticketData?.receipt.imp_vcf && parseFloat(ticketData?.receipt.imp_vcf)?.toFixed(4)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>Nguồn tái xuất:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      {/* Công thức warning txtxL15 = txtxLTT/lit*l15*/}
                      <TableCell align="left">
                        <TextField
                          type="number"
                          label="LTT"
                          value={Math.round(inputData.tntxLTT) || ""}
                          onChange={(e) =>
                            setInputData((prev) => ({
                              ...prev,
                              tntxLTT: Math.round(e.target.value),
                              tntxL15: Math.round((e.target.value / ticketData.receipt.lit) * ticketData.receipt.l15),
                              tntxKG: Math.round((e.target.value / ticketData.receipt.lit) * ticketData.receipt.kg),
                            }))
                          }
                        />
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          type="number"
                          label="KG"
                          value={Math.round(inputData.tntxKG) || ""}
                          onChange={(e) =>
                            setInputData((prev) => ({
                              ...prev,
                              tntxKG: Math.round(e.target.value),
                              tntxLTT: Math.round((e.target.value / ticketData.receipt.kg) * ticketData.receipt.lit),
                              tntxL15: Math.round((e.target.value / ticketData.receipt.kg) * ticketData.receipt.l15),
                            }))
                          }
                        />
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          type="number"
                          label="L15"
                          value={Math.round(inputData.tntxL15) || ""}
                          onChange={(e) =>
                            setInputData((prev) => ({
                              ...prev,
                              tntxL15: Math.round(e.target.value),
                              tntxLTT: Math.round((e.target.value / ticketData.receipt.l15) * ticketData.receipt.lit),
                              tntxKG: Math.round((e.target.value * ticketData.receipt.kg) / ticketData.receipt.l15),
                            }))
                          }
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {exp_inventories.includes(ticketData?.receipt.to_inventory_id) && (
              <Button variant="contained" sx={{ marginRight: "10px", marginBottom: "10px" }} onClick={() => handleCheckImpReceipt()}>
                Kiểm tra nhập hàng
              </Button>
            )}
            <ButtonWithAPICallComponent api={handleSubmit} response={handleSaveResponse} variant="contained" sx={{ marginBottom: "10px" }}>
              {t("Lưu")}
            </ButtonWithAPICallComponent>
          </div>
          <div hidden={hidden} ref={currentTab === 0 ? printRef : null}>
            <TicketPreview data={ticketData} />
          </div>
        </div>
      </TicketContext.Provider>
    );
  return "";
}
export function ExpTicketDetail({ ticketid, onClickAtReplaceId, onDelete }) {
  // custom hook
  const [t] = useTranslation();
  const history = useHistory();
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // state
  const [isAllow, setAllow] = useState(true);
  const [ticketData, setTicketData] = useState(null);
  const [dialogNumber, setDialogNumber] = useState(false);
  const [hidden, setHidden] = useState(true);

  // methods
  const handleDeleteAction = () => {
    return deleteTicket(ticketid);
  };
  const handleDeleteResponse = (res) => {
    if (res.code === 200) {
      try {
        let newTicketData = JSON.parse(JSON.stringify(ticketData)); // deep clone current ticket data
        newTicketData.receipt.status = "DELETED";
        setTicketData(newTicketData);
        onDelete(ticketid);
      } catch (error) {}
    }
  };
  const handleSendAction = () => {};
  const fetchNewData = () => {
    getTickets({ id: ticketid }).then((res) => {
      if (res.code === 403) {
        setAllow(false);
        return;
      }
      res.code === 200 && setTicketData(res.data);
    });
  };

  // effect
  useEffect(() => {
    if (!hidden) {
      handlePrint();
      setHidden(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);
  useEffect(() => {
    if (!ticketid) return;
    fetchNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketid]);
  if (!isAllow) return t("No permission");
  if (ticketData)
    return (
      <div>
        <div style={{ justifyContent: "right", display: "flex", backgroundColor: "#b3deff", alignItems: "center" }}>
          <ButtonGroup style={{ height: 50 }}>
            <Tooltip title="In lại">
              <Button variant="outlined" color="primary" onClick={() => setHidden(false)}>
                <PrintIcon />
              </Button>
            </Tooltip>
            {ticketData.receipt?.status !== "FAIL" && (
              <Tooltip title="Xem file PDF">
                <ButtonWithAPICallComponent
                  disableSnackbar={() => true}
                  variant="outlined"
                  api={() => {
                    return getRPTPDF(ticketid);
                  }}
                  response={(res) => {
                    res.code === 200 && window.open(res.data);
                  }}
                >
                  <PictureAsPdfIcon />
                </ButtonWithAPICallComponent>
              </Tooltip>
            )}

            {/* {(ticketData.receipt?.status === "PUBLISHED" || ticketData.receipt?.status === "REPLACE") && (
              <Tooltip title="Phát hành thay thế">
                <Button variant="outlined" color="primary" onClick={() => history.push({ pathname: `/editticket/${ticketData.receipt.id}`, state: ticketData })}>
                  <RepeatOneIcon />
                </Button>
              </Tooltip>
            )} */}
            {(ticketData.receipt?.status === "PUBLISHED" || ticketData.receipt?.status === "REPLACE") && (
              <Tooltip title="Huỷ">
                <ButtonWithAPICallComponent variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                  <DeleteIcon />
                </ButtonWithAPICallComponent>
              </Tooltip>
            )}
          </ButtonGroup>
        </div>
        <div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <h2>PHIẾU XUẤT: {ticketData.receipt?.code}</h2>
            <div className={`status ${ticketData.receipt?.status}`} style={{ color: statusColor[ticketData.receipt?.status] }}>
              {t(ticketData.receipt?.status)}
            </div>
            &nbsp;
            {ticketData?.receipt?.replaced_code && (
              <div style={{ display: "flex", color: statusColor[ticketData.receipt?.status] }} className={`status ${ticketData.receipt.status}`}>
                cho hoá đơn số: &nbsp;
                <div style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => onClickAtReplaceId(ticketData?.receipt?.replaced_id)}>
                  {ticketData?.receipt?.replaced_code}
                </div>
              </div>
            )}
          </div>
          <div align="left" style={{ marginBottom: 5 }}>
            <b>{t("Thông tin kho phiếu xuất")}</b>:
          </div>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">
                    {t("Kho xuất")}: {ticketData?.receipt.from_inventory}
                  </TableCell>
                  <TableCell align="left">
                    {t("Serial số")}: {ticketData?.receipt.serial}
                  </TableCell>
                  <TableCell align="left">
                    {t("Form số")}: {ticketData?.receipt.form_no}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Thời gian bắt đầu")}: {ticketData?.receipt.date && moment(ticketData.receipt.date).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Thời gian kết thúc")}: {ticketData?.receipt.enddate && moment(ticketData.receipt.enddate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Phương tiện")}: {ticketData?.receipt.license_plate}
                  </TableCell>
                  <TableCell align="left">
                    {t("Người điều khiển")}: {ticketData?.receipt.driver}
                  </TableCell>
                  <TableCell align="left">
                    {t("Lệnh điều động số")}: {ticketData?.receipt.orderno}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Chứng chỉ kho xuất số/ngày")}: {ticketData?.receipt.inventory_cert}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Phiếu nhập/Ký hiệu")}: {ticketData?.receipt.ext_inv_serial}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Lit: {Math.round(ticketData?.receipt.lit)?.toLocaleString()}</TableCell>
                  <TableCell align="left" colSpan={2}>
                    L15: {Math.round(ticketData?.receipt.l15)?.toLocaleString()}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Ngày xuất hóa đơn")}: {ticketData?.receipt.billdate && moment(ticketData.receipt.billdate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left">
                    {t("Số hợp đồng")}: {ticketData?.receipt.contract_no}
                  </TableCell>
                  <TableCell align="left">
                    {t("Ngày hợp đồng")}: {ticketData?.receipt.contract_date && moment(ticketData.receipt.contract_date).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div>
            <div align="left" style={{ margin: "10px 0", display: "flex" }}>
              <div style={{ width: "auto" }}>
                <b>{t("Khoảng cách tầm mức")}:</b>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: `repeat(${JSON.parse(ticketData.receipt.ext_vh_tanks).length}, 1fr)`, gridColumnGap: 20 }}>
                {JSON.parse(ticketData.receipt.ext_vh_tanks).map((item, index) => (
                  // <TextField InputLabelProps={{shrink: true}} key={index} label={item.code} value={item.lit || ''}/>
                  <div key={index}>
                    {item.code}: {item.lit};
                  </div>
                ))}
              </div>
            </div>
            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>{t("Thông tin hàng hóa")}:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("STT")}</TableCell>
                      <TableCell>{t("Mã hàng hóa")}</TableCell>
                      <TableCell>{t("Tên hàng hóa")}</TableCell>
                      <TableCell>{t("Nhiệt độ")}</TableCell>
                      <TableCell>D15</TableCell>
                      <TableCell>VCF</TableCell>
                      <TableCell>WCF</TableCell>
                      <TableCell>Lit</TableCell>
                      <TableCell>Lit (15℃)</TableCell>
                      <TableCell>Kg</TableCell>
                      <TableCell>{t("Bồn xuất")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ticketData.receiptproduct &&
                      ticketData.receiptproduct.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.id}</TableCell>
                          <TableCell>{item.product_name}</TableCell>
                          <TableCell>{item.temp && parseFloat(item.temp)?.toFixed(2)}</TableCell>
                          <TableCell>{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                          <TableCell>{item.vcf && parseFloat(item.vcf)?.toFixed(4)}</TableCell>
                          <TableCell>{item.wcf && parseFloat(item.wcf)?.toFixed(4)}</TableCell>
                          <TableCell>{Math.round(item.lit)?.toLocaleString()}</TableCell>
                          <TableCell>{Math.round(item.l15)?.toLocaleString()}</TableCell>
                          <TableCell>{Math.round(item.kg)?.toLocaleString()}</TableCell>
                          <TableCell>{item.tank && JSON.parse(item.tank)?.code}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          <div>
            <div align="left" style={{ marginBottom: 5 }}>
              <b>Thông tin kho nhập:</b>
            </div>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      {t("Kho nhập")} : {ticketData?.receipt.to_inventory}
                    </TableCell>
                    <TableCell align="left">
                      {t("Ngày")} : {ticketData && moment(ticketData.receipt.date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell align="left">
                      {t("Giờ")} : {moment(ticketData?.receipt.date).format("HH:mm")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">ERP ID: {ticketData?.receipt.erp_id}</TableCell>
                    <TableCell align="left">Số CTT ERP: {ticketData?.receipt.erp_code}</TableCell>
                    <TableCell align="left" colSpan={2}>
                      Fkey: {ticketData?.receipt.fkey}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">Lit: {Math.round(ticketData?.receipt.imp_lit)?.toLocaleString()}</TableCell>
                    <TableCell align="left">L15: {Math.round(ticketData?.receipt.imp_l15)?.toLocaleString()}</TableCell>
                    <TableCell align="left">
                      {t("Chênh lệch")}: {Math.round(ticketData?.receipt.gap)?.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                                    <TableCell align='left' colSpan={3}>Re-export: {ticketData?.receipt.reexport_quantity?.toLocaleString()}</TableCell>
                                </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div style={{ margin: "10px 0" }}>
            <div align="left" style={{ marginBottom: 5 }}>
              <b>Thông tin hóa nghiệm:</b>
            </div>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      {t("Nhiệt độ")} : {ticketData?.receipt.imp_temp && parseFloat(ticketData?.receipt.imp_temp).toFixed(2)}
                    </TableCell>
                    <TableCell align="left">
                      {t("Tỷ trọng")} : {ticketData?.receipt.imp_density && parseFloat(ticketData?.receipt.imp_density).toFixed(4)}
                    </TableCell>
                    <TableCell align="left">D15: {ticketData?.receipt.imp_d15 && parseFloat(ticketData?.receipt.imp_d15)?.toFixed(4)}</TableCell>
                    <TableCell align="left">VCF: {ticketData?.receipt.imp_vcf && parseFloat(ticketData?.receipt.imp_vcf)?.toFixed(4)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        {/* hidden stuff, */}
        <div hidden={hidden} ref={printRef}>
          <TicketPreview data={ticketData} />
        </div>
        <Dialog open={dialogNumber === "send"} onClose={() => setDialogNumber(false)}>
          <Paper style={{ width: 400, textAlign: "center" }}>
            <div style={{ justifyContent: "space-between", display: "flex", padding: "30px 20px", borderBottom: "1px solid lightgray" }}>
              <div align="left" style={{ fontSize: 22 }}>
                Send
              </div>
              <div style={{ position: "relative", bottom: 13 }}>
                <IconButton onClick={() => setDialogNumber(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <div style={{ padding: "20px 20px 30px 20px", borderBottom: "1px solid lightgray" }}>Are you sure you want to send this item?</div>
            <div style={{ padding: 20 }}>
              <Button color="warning" variant="contained" style={{ marginRight: 50 }} onClick={handleSendAction}>
                Yes
              </Button>
              <Button color="primary" variant="contained" onClick={() => setDialogNumber(false)}>
                No
              </Button>
            </div>
          </Paper>
        </Dialog>
      </div>
    );
  return "";
}
